// eslint-disable-next-line no-restricted-imports
import { DialogContent, Divider, dividerClasses, IconButton, styled } from "~/common/mui";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export { DialogHeader } from "~/common/mui/Dialog/Dialog";

export const StyledDivider = styled(Divider)({
  flex: "none",
  [`& .${dividerClasses.wrapperVertical}`]: {
    paddingInline: "0",
  },
});

export const DrawerContent = styled(DialogContent)({
  padding: "16px",
});

export const DrawerHeader = styled((props: JSX.IntrinsicElements["div"] & { onClose?: () => void }) => {
  const { onClose, children, ...rest } = props;
  return (
    <div {...rest}>
      <div>{children}</div>
      <IconButton variant="contained" color={"secondary"} size={"medium"} onClick={onClose}>
        <CloseRoundedIcon />
      </IconButton>
    </div>
  );
})({
  padding: "16px 16px 0 16px",
  marginBottom: "8px",
  display: "grid",
  gridTemplateColumns: "1fr auto",
  alignItems: "center",
  ["& .MuiIconButton-sizeMedium"]: {
    margin: "4px",
  },
});
